<template>
	<div class="follow-order">
		<div class="box">
			<span class="title">{{ isBuilding ? 'افزودن ساختمان جدید' : 'افزودن مجتمع / گروه ساختمان' }}</span>
            <p class="building-location-help">کد {{ isBuilding ? 'ساختمان' : 'گروه ساختمان' }} پس از ثبت به‌صورت خودکار ساخته می‌شود.</p>
            <p v-if="createdRecord" class="building-created" role="status">«{{ createdRecord.verbose_name }}» ثبت شد. کد: <b dir="ltr">{{ createdRecord.code }}</b><span v-if="createdRecord.managementName"> · مدیر ساختمان: {{ createdRecord.managementName }}</span> · <router-link :to="'/elevatormanagement/buildingdetail/' + createdRecord.id">مشاهده جزئیات</router-link> · <router-link v-if="isBuilding" :to="{name:'createElevator',params:{id:createdRecord.id}}">افزودن آسانسور</router-link></p>
            <p v-if="error" ref="error" class="building-error" role="alert" tabindex="-1">{{ error }}</p>
			<form class="form-container" @submit.prevent="submitForm">
				<div class="row mt-4">
					<div class="col-md-6 mb-3">
						<label for="buildingName">نام ساختمان:</label>
						<input
							id="buildingName"
							v-model.trim="verbose_name" required maxlength="255"
							class="inputs"
							placeholder="نام ساختمان را وارد کنید"
						/>
					</div>


					<!-- <div class="col-md-6 mb-3">
						<label for="buildingType">نوع ساختمان:</label>
						<select id="buildingType" @change="getBuildingType" v-model="type" class="form-select">
							<option value="" disabled selected>انتخاب کنید</option>
							<option value="Complex">مجتمع</option>
							<option value="Apartment">ساختمان</option>
						</select>
					</div> -->

					<div class="col-md-6 mb-3">
						<label for="province">استان:</label>
						<select
							id="province"
							v-model="pickProvince" required
                            :disabled="busy || provincesLoading || !projectId" :aria-busy="provincesLoading" aria-describedby="province-feedback"
							class="form-select"
							@change="getCityOnChange"
						>
							<option value="" disabled>{{ provincesLoading ? 'دریافت استان‌ها…' : 'ابتدا استان را انتخاب کنید' }}</option>
							<option v-for="province in provinceLists" :value="province.id" :key="province.id">
								{{ province.name }}
							</option>
						</select>
                        <p id="province-feedback" class="building-location-help" :class="{ 'location-error': provinceError }" :role="provinceError ? 'alert' : 'status'">{{ provinceError || (provincesLoading ? 'در حال دریافت استان‌ها…' : 'استان را انتخاب کنید تا شهرهای فعال همین پروژه نمایش داده شوند.') }}<button v-if="provinceError" type="button" :disabled="provincesLoading || busy" @click="getProvinceList">تلاش دوباره</button></p>
					</div>

					<div class="col-md-6 mb-3">
						<label for="city">شهر:</label>
						<select
							id="city"
							v-model="selectedkCity" required
                            :aria-busy="citiesLoading" aria-describedby="city-feedback"
							class="form-select"
							:disabled="busy || !pickProvince || citiesLoading || !cityLists.length"
						>
							<option value="" disabled>{{ cityPlaceholder }}</option>
							<option v-for="city in cityLists" :value="city.city.id" :key="city.city.id">
								{{ city.city.name }}
							</option>
						</select>
                        <p id="city-feedback" class="building-location-help" :class="{ 'location-error': cityError }" :role="cityError ? 'alert' : 'status'">{{ cityError || (citiesLoading ? 'در حال دریافت شهرهای استان…' : !pickProvince ? 'ابتدا استان را انتخاب کنید.' : !cityLists.length ? 'برای این استان شهری در پروژه فعال نشده است؛ تنظیم شهرهای فعال پروژه را بررسی کنید.' : 'فقط شهرهای فعال این استان در پروژه قابل انتخاب‌اند.') }}<button v-if="cityError" type="button" :disabled="citiesLoading || busy" @click="getCity">تلاش دوباره</button></p>
					</div>
					<div class="col-md-6 mb-3" v-if="complexInput">
						<label for="building-complex">انتخاب مجتمع:</label>
						<select id="building-complex" v-model="selectedComplex" class="form-select">
							<option value="" disabled selected>انتخاب کنید</option>
							<option v-for="complex in complexList" :value="complex.id" :key="complex.id">
								{{ complex.verbose_name }}
							</option>
						</select>
					</div>

					<div class="col-md-12 col-lg-12 mb-3">
                        <label for="building-address">آدرس کامل ساختمان:</label>
                        <textarea id="building-address" v-model.trim="address" required rows="3" class="inputs address-input" placeholder="نشانی کامل ساختمان را وارد کنید" />
                        <p class="building-map-help">آدرس را جست‌وجو کنید یا نقطه را روی نقشه انتخاب کنید؛ نشانی پیشنهادی در کادر بالا قرار می‌گیرد و قابل ویرایش است.</p>
                        <PointPicker label="ساختمان" :address="address" :latitude="latitude" :longitude="longitude" :disabled="busy" @select="selectPoint" @address="address = $event" @resolving="addressBusy = $event" />
                        <details class="building-coordinates"><summary>ورود یا اصلاح دستی مختصات</summary><div class="row mt-3"><label class="col-md-6">عرض جغرافیایی<input v-model="latitude" class="inputs" type="number" step="any" min="-90" max="90" dir="ltr"></label><label class="col-md-6">طول جغرافیایی<input v-model="longitude" class="inputs" type="number" step="any" min="-180" max="180" dir="ltr"></label></div></details>

					</div>
				</div>

				<BuildingClientPicker v-model="selectedClient" :project="projectId" :disabled="busy" />
				<div class="mt-4 d-flex justify-content-end">
					<button :disabled="isFormValid" type="submit" class="btn accept">
						{{ busy ? 'در حال ثبت…' : addressBusy ? 'دریافت نشانی…' : 'ثبت ساختمان' }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { errorText } from '@/utils/executionAdmin';
export default {
	components: {
		PointPicker: () => import('@/components/Map/PointPicker.vue'),
		BuildingClientPicker: () => import('@/components/BuildingClientPicker.vue'),
	},
	data() {
		return {
			selectedClient: null,
			provincesLoading: false, citiesLoading: false, provinceError: '', cityError: '', provinceRequest: 0, cityRequest: 0,
			provinceLists: [],
			cityLists: [],
			latitude: '', longitude: '', busy: false, addressBusy: false, error: '', createdRecord: null,
			selectedkCity: '',
			pickProvince: '',
			verbose_name: '',
			type: '',
			address: '',
			complexInput: false,
			complexList: [],
			selectedComplex: '',
		};
	},

	mounted() {
		this.getProvinceList();
	},
    beforeDestroy() { this.provinceRequest++; this.cityRequest++; },
    watch: { projectId() { this.provinceRequest++; this.cityRequest++; this.pickProvince = ''; this.selectedkCity = ''; this.cityLists = []; this.provinceLists = []; this.citiesLoading = false; this.cityError = ''; this.createdRecord = null; this.selectedClient = null; this.getProvinceList(); } },
    computed: {
        projectId() { return this.$STORE.state.userConfig.setProjectId; },
        cityPlaceholder() { return !this.pickProvince ? 'ابتدا استان را انتخاب کنید' : this.citiesLoading ? 'دریافت شهرها…' : this.cityError ? 'دریافت شهرها انجام نشد' : !this.cityLists.length ? 'شهر فعالی در این استان نیست' : 'شهر را انتخاب کنید'; },
        isBuilding() { return !!this.$route.params.id || this.$route.query.kind === 'building'; },
        hasPoint() {
            const lat = Number(this.latitude), lng = Number(this.longitude);
            return this.latitude !== '' && this.longitude !== '' && Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
        },
		isFormValid() {
			if (
				!this.busy && !this.addressBusy && !this.provincesLoading && !this.citiesLoading && !this.provinceError && !this.cityError && this.verbose_name.trim() !== '' &&
				
				this.selectedkCity !== '' && this.cityLists.some(row => String(row.city.id) === String(this.selectedkCity)) &&
				this.pickProvince !== '' &&
				this.hasPoint && this.address.trim() &&
				(!this.complexInput || (this.complexInput && this.selectedComplex !== ''))
			) {
				return false;
			}
			return true;
		},
	},
	methods: {
		async getProvinceList() {
            const request = ++this.provinceRequest, project = this.projectId;
            this.provincesLoading = true; this.provinceError = '';
            if (!project) { this.provincesLoading = false; this.provinceError = 'ابتدا پروژه را انتخاب کنید.'; return; }
            try {
                const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST + '?p=' + encodeURIComponent(project) + '&ordering=name', this.$PATH.SERVICE_NAME.AUTH);
                if (request !== this.provinceRequest || project !== this.projectId) return;
                if (res.status !== 200) throw new Error(errorText(this.$ApiServiceLayer, res));
                const rows = Array.isArray(res.data) ? res.data : res.data && res.data.results;
                if (!Array.isArray(rows)) throw new Error('دریافت فهرست استان‌ها کامل نشد. دوباره تلاش کنید.');
                this.provinceLists = rows;
                if (!rows.length) this.provinceError = 'هنوز استانی در فهرست ثبت نشده است.';
            } catch (e) { if (request === this.provinceRequest && project === this.projectId) this.provinceError = e.message || 'دریافت استان‌ها انجام نشد.'; }
            finally { if (request === this.provinceRequest && project === this.projectId) this.provincesLoading = false; }
        },
		getBuildingType() {
			if (this.type === 'Apartment') {
				this.complexInput = true;
				this.getComplexList();
			} else {
				this.complexInput = false;
			}
		},
		getCityOnChange() { return this.getCity(); },
        selectPoint(point) { this.latitude = point.latitude; this.longitude = point.longitude; },
        async getCity() {
            const request = ++this.cityRequest, province = this.pickProvince, project = this.projectId;
            this.selectedkCity = ''; this.cityLists = []; this.cityError = ''; this.citiesLoading = false;
            if (!province || !project) return;
            this.citiesLoading = true;
            try {
                const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST + '?city__province=' + encodeURIComponent(province) + '&p=' + encodeURIComponent(project) + '&ordering=city__name', this.$PATH.SERVICE_NAME.AUTH);
                if (request !== this.cityRequest || province !== this.pickProvince || project !== this.projectId) return;
                if (res.status !== 200) throw new Error(errorText(this.$ApiServiceLayer, res));
                const rows = Array.isArray(res.data) ? res.data : res.data && res.data.results;
                if (!Array.isArray(rows)) throw new Error('دریافت فهرست شهرها کامل نشد. دوباره تلاش کنید.');
                this.cityLists = rows.filter(row => row.city && row.city.id && row.city.province && String(row.city.province.id) === String(province));
            } catch (e) { if (request === this.cityRequest && province === this.pickProvince && project === this.projectId) this.cityError = e.message || 'دریافت شهرها انجام نشد.'; }
            finally { if (request === this.cityRequest && province === this.pickProvince && project === this.projectId) this.citiesLoading = false; }
        },
		async getComplexList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_BUILDING_LIST_CREATE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_active=true' +
					'&parent__isnull=true',
				'',
			);
			if (res.status === 200) {
				this.complexList = res.data;
			}
		},
		async submitForm() {
            if (this.isFormValid) return; this.busy = true; this.error = ''; this.createdRecord = null;
            const project = this.projectId;
            try {
			const data = {
				verbose_name: this.verbose_name,
				type: this.isBuilding ? 'Apartment' : 'Complex',
				address: this.address,
				city: this.selectedkCity,
				parent: this.$route.params.id ? this.$route.params.id : null,
				longitude: this.longitude,
				latitude: this.latitude,
				...(this.selectedClient ? { client: this.selectedClient.id } : {}),
			};
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.VISIT_BUILDING_LIST_CREATE + '?p=' + this.$STORE.state.userConfig.setProjectId,
				'',
				data,
			);
			if (res.status !== 201) throw new Error(errorText(this.$ApiServiceLayer, res));
			if (project !== this.projectId) return;
			if (res.status === 201) {
                this.createdRecord = { ...res.data, managementName: this.selectedClient && (this.selectedClient.name_fa || this.selectedClient.name) };
				this.selectedClient = null;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'ثبت شد؛ کد: ' + res.data.code,
				});
				this.verbose_name = '';
				this.type = '';
				this.selectedkCity = '';
				this.pickProvince = '';
				this.latitude = ''; this.longitude = ''; this.address = ''; this.cityLists = [];
                this.selectedComplex = '';
            }
            } catch (e) { this.error = e.message || 'ثبت ساختمان انجام نشد.'; this.$nextTick(() => this.$refs.error && this.$refs.error.focus()); } finally { this.busy = false; }
        },
	},
};
</script>

<style lang="scss" scoped>
.building-created { padding:16px; background:#eaf8f0; color:#226345; border-radius:10px; line-height:1.9 }
.building-location-help { margin:8px 0 0; font-size:12px; color:#65758d; line-height:1.8 }
.building-location-help.location-error { color:#972b2b }
.building-location-help button { margin-inline-start:8px; border:1px solid currentColor; border-radius:6px; background:white; padding:4px 10px; color:inherit; min-height:36px }
.building-error { padding:16px; background:#fff0ef; color:#972b2b; border-radius:10px; white-space:pre-wrap }
.building-map-help { margin:16px 0; color:#65758d; font-size:13px; line-height:1.9 }
.building-coordinates { margin-top:20px }
.building-coordinates summary { min-height:44px; cursor:pointer; color:#3453a1 }
.follow-order {
	padding: 32px 50px;

	.box {
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		box-shadow: 0px 4px 4px rgba(214, 214, 214, 0.6);

		.title {
			font-weight: 700;
			font-size: 18px;
		}
	}

	.inputs {
		width: 100%;
		height: 38px;
		border: 1px solid #c4c4c4;
		padding: 0 9px;
		border-radius: 4px;
		font-family: 'IRANYekanfa' !important;
	}

	.address-input {
		height: 80px;
		padding: 9px;
		resize: none;
	}

	.form-select {
		width: 100%;
		border: 1px solid #c4c4c4;
		height: 38px;
		padding: 0 9px;
		border-radius: 4px;
		color: #828282;
	}

	.accept {
		height: 38px;
		background: #357ae1;
		border-radius: 4px;
		color: #fff;
		border: none !important;
		width: 120px;
	}

	.remove-filtes {
		border: 1px solid #357ae1;
		border-radius: 4px;
		color: #357ae1;
		height: 38px;
		background: #fff;
		width: 100px;
	}

	.form-check-input {
		margin-left: 8px;
	}

	.form-check-label {
		margin-right: 8px;
	}
}
@media(max-width:600px) {
    .follow-order { padding:16px 8px }
    .follow-order .box { padding:16px }
}

@media (max-width: 768px) {
	.follow-order {
		padding: 16px;

		.box {
			padding: 16px;
		}
	}
}
</style>
